import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faLungsVirus, 
  faXRay,
  faRoadBarrier,
  // Add other icons as needed
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export const AbcdefReminder: React.FC = () => {
  const { t } = useTranslation('resus');
  return (
    <ul>
      <li>
        <span className="icon"><FontAwesomeIcon icon={faPhone} /></span>
        <span className="text">{t('reminders.callOnCall')}</span>
      </li>
      <li>
        <span className="icon"><FontAwesomeIcon icon={faLungsVirus} /></span>
        <span className="text">POCUS</span>
      </li>
      <li>
        <span className="icon"><FontAwesomeIcon icon={faXRay} /></span>
        <span className="text">{t('reminders.chestXRay')}</span>
      </li>
    </ul>
  );
};

export const CprBoardReminder: React.FC = () => {
  const { t } = useTranslation('resus');
  return (
    <ul>
      <li>
        <span className="icon"><FontAwesomeIcon icon={faRoadBarrier} /></span>
        <span className="text">{t('reminders.dontForgetBoard')}</span>
      </li>
    </ul>
  );
};